import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { STATIC_VALUE } from '../../shared/configuration/static.value';

import { PageNavigationService } from '../../shared/services/page-navigation.service';
import { LayoutService } from '../../shared/services/layout.service';
import { StorageService } from '../../shared/services/storage.service';
import { PlantMapService } from '../services/plant-map.service';

@Component({
    selector: 'plantmap-confirmation',
    templateUrl: 'confirmation.component.html'
})

export class PlantmapConfirmationComponent implements OnInit{

    vEmail: string;
    vStatus: string;
    restrictedArea: number;

    vPlantRequestID: string;
    isRestrictedArea_skip_payment:boolean;
    constructor(
        private _plantmapService: PlantMapService,
        private _layoutService: LayoutService,
        private _storageService: StorageService,
        private _pageNavigationService: PageNavigationService,
        private _activatedRoute: ActivatedRoute
    ) {
        
    }

    ngOnInit() {
        this._layoutService.setCurrentPage('plantmap-confirmation');
        this.vPlantRequestID = this._plantmapService.getRequestId();
        this.isRestrictedArea_skip_payment = this._plantmapService.isRestrictedArea_skip_payment();
       // alert("this.vPlantRequestID"+this.vPlantRequestID)
        //alert("this.vPlantRequestID"+this.isRestrictedArea_skip_payment)
        if(this.isRestrictedArea_skip_payment){
            this.vStatus = 'PM_98';
        }
        else{
            console.log("Line 37",this._activatedRoute.snapshot.queryParams);
            this.restrictedArea = this._plantmapService.vAreaOfInterestData.restricted_area;
            this._plantmapService.getPaymentAvailability().then(
                    (resolve) => {
                        //               alert('111-->'+this._plantmapService.vAreaOfInterestData.restricted_area);
                        if(resolve['data'].payment) { // contractor
                            let transactionParam = this._activatedRoute.snapshot.queryParams;
                            console.log(this._activatedRoute.snapshot.queryParams);
                           // alert(this._plantmapService.vPlantMapData.success_indicator);
                            if(transactionParam["resultIndicator"] !== undefined && transactionParam["resultIndicator"] === this._plantmapService.vPlantMapData.success_indicator){
                                this.loadTransaction(transactionParam);             
                            } else {
                                this.vStatus = STATIC_VALUE.ALL_PLANT_STATUS.PAYMENT_FAILED;
                            }

                        } else { 

                           // alert('222-->'+this._plantmapService.vAreaOfInterestData.restricted_area);
                            if(this._plantmapService.vAreaOfInterestData.restricted_area == 1){
                                this.vStatus = STATIC_VALUE.ALL_PLANT_STATUS.PENDING_MAP_COLLECTION;
                            } else {
                                this.vStatus = STATIC_VALUE.ALL_PLANT_STATUS.PAYMENT_RECEIVED;
                            }
                            this._plantmapService.gisPlantmapHit();
                            this._plantmapService.resetAllData();
                        }

                    },
                    (reject) => {
                        this._plantmapService.resetAllData();
                    }
                );
        }
    }

    loadTransaction(transactionParam){
    this._plantmapService.loadTransaction(transactionParam["failure_reason"]).then(
            (resolve) => {
                console.log("Line 68",resolve['data'].status);
                this.vStatus = resolve['data'].status;
                if(this.vStatus == STATIC_VALUE.ALL_PLANT_STATUS.PAYMENT_RECEIVED) {
                    this._plantmapService.gisPlantmapHit();
                    this._plantmapService.resetAllData();
                } else {
                    this._plantmapService.resetAllData();
                }
            },
            (reject) => {
                this._plantmapService.resetAllData();
            }
        );
    }

    getPlantmapStatus(){
        return STATIC_VALUE.ALL_PLANT_STATUS;
    }

    isLoading(){
        return this._plantmapService.isLoading();
    }

    goToHome(){
        let vLink = ['home'];
        this._pageNavigationService.navigate(vLink);
    }

 
}


// WEBPACK FOOTER //
// /home/maheshreddy/PRP_FE/src/app/plantmap/components/confirmation.component.ts